import React from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { SEOHead } from '../components/SEOHead';

/**
 * Catch-all 404 page. Sent for any URL that doesn't match a real route so
 * the app never shows a blank screen on typos or stale links. SEOHead
 * injects `<meta name="robots" content="noindex, nofollow">` so Google
 * drops these dead URLs from its index instead of treating them as soft 404s.
 */
export function NotFoundPage() {
  return (
    <>
      <SEOHead
        title="Page Not Found — SitgesVibes"
        description="The page you're looking for doesn't exist or may have moved."
        noindex
      />
      <main
        className="min-h-[60vh] max-w-[820px] mx-auto px-5 sm:px-8 pt-[212px] pb-20 flex flex-col items-center justify-center text-center"
        style={{ fontFamily: "'Outfit', sans-serif" }}
        data-testid="not-found-page"
      >
        <span
          className="text-[96px] sm:text-[128px] font-bold leading-none"
          style={{ color: '#1a4d7a', letterSpacing: '-0.04em' }}
          aria-hidden="true"
        >
          404
        </span>
        <h1
          className="text-3xl sm:text-4xl font-bold mt-4 mb-3"
          style={{ color: '#1a4d7a' }}
        >
          We couldn't find that page
        </h1>
        <p
          className="text-base sm:text-lg max-w-[520px] mb-8"
          style={{ color: '#2d5f8d' }}
        >
          The link you followed may be broken or the page may have moved.
          Let's get you back to discovering Sitges.
        </p>
        <div className="flex flex-col sm:flex-row gap-3">
          <Link
            to="/"
            data-testid="not-found-home-link"
            className="h-12 px-8 rounded-full bg-[#3c84ff] hover:bg-[#2a6fe0] text-white text-sm font-semibold transition-colors active:scale-95 inline-flex items-center justify-center"
          >
            Back to homepage
          </Link>
          <Link
            to="/Explore"
            data-testid="not-found-explore-link"
            className="h-12 px-8 rounded-full bg-white border border-[#1a4d7a] text-[#1a4d7a] hover:bg-[#eaf3fa] text-sm font-semibold transition-colors active:scale-95 inline-flex items-center justify-center"
          >
            Browse all experiences
          </Link>
        </div>
      </main>
      <Footer />
    </>
  );
}

export default NotFoundPage;
